import * as React from "react";
// eslint-disable-next-line @1js/office-online-rules/no-v8-imports-for-fluentui -- disabling for existing usage
import type { IButtonProps, IRenderFunction } from "@fluentui/react";
import { mergeClasses } from "@fluentui/react-components";
import { ActionControlSize, textContainerClassName } from "@1js/acui-common";
import { renderLargeControlText } from "../../../renderLargeControlTextFunction";
import type { RibbonButtonState } from "./RibbonButton.types";

/** Renders content in place of the control label. Handles MLR large multiline labels. */
export const useRibbonControlLabel = (
  label: string,
  size?: RibbonButtonState["size"],
  onRenderText?: IRenderFunction<IButtonProps> | undefined,
  classNames?: string
) => {
  if (!size && onRenderText) {
    return onRenderText();
  }
  if (size?.toLowerCase() === ActionControlSize.Large.toLowerCase()) {
    return renderLargeControlText(label, classNames);
  }
  const className = mergeClasses(textContainerClassName, classNames);
  return <span className={className}>{label}</span>;
};
